import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Bell } from "lucide-react";
import { useNavigate } from "react-router-dom";

const NotificationPopup = ({ notification, onClose }) => {
  const router = useNavigate();
  const { title, body, link,time } = notification;
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (!isHovered) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [isHovered, onClose]);

  return (
    <AnimatePresence>
  {notification && (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 50 }}
      style={{
        width: "25rem", // w-80
        backgroundColor: "white", // bg-white
        boxShadow: "0 10px 15px rgba(0, 0, 0, 0.1)", // shadow-lg
        borderRadius: "0.75rem", // rounded-xl
        padding: "1rem", // p-4
        display: "flex", // flex
        alignItems: "flex-start", // items-start
        gap: "0.75rem", // space-x-3
        border: "1px solid #e5e7eb", // border-gray-200
        position: "relative", // relative
        zIndex: 50, // z-50
        marginTop:"15px"
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Bell style={{ color: "#3b82f6", width: "1.5rem", height: "1.5rem", marginTop: "0.25rem" }} />

      <div style={{ flex: 1,gap:"10px" }}>
        <h4 style={{ fontWeight: 600, color: "#1f2937",padding:"5px" /* text-gray-800 */ }}>{title}</h4>
        <p style={{ fontSize: "0.875rem", color: "#4b5563",padding:"5px",paddingTop:"0px"/* text-gray-600 */ }}>{body}</p>

        <button
  onClick={() => {
    onClose();
    router(link)}}
  style={{
    marginTop: "0.25rem",
    color: "#ffffff",               // White text
    backgroundColor: "#3b82f6",     // Black background
    borderRadius:"5px",
    border: "none",
    cursor: "pointer",
    padding: "5px",
    paddingRight:"10px",
    paddingLeft:"10px",
    textDecoration: "underline",

  }}
>
  View
</button>
      </div>

      <button
        onClick={onClose}
        style={{
          color: "#9ca3af", // text-gray-400
          border: "none",
          background: "none",
          cursor: "pointer",
        }}
        onMouseOver={(e) => (e.currentTarget.style.color = "#4b5563")}
        onMouseOut={(e) => (e.currentTarget.style.color = "#9ca3af")}
      >
        <X style={{ width: "1.25rem", height: "1.25rem" }} />
      </button>
    </motion.div>
  )}
</AnimatePresence>

  );
};

export default NotificationPopup;